import React from 'react';
import TopInfluencers from 'components/page-influencers/top-influencers';
import AllInflReq from 'components/page-influencers/all-influencers-requested';

import Meta from 'shared/meta';

function InfluencersComingSoonPage({ pageContext }) {
  const { influencers } = pageContext;


  return (
    <main>
      <Meta />
      <TopInfluencers influencers={influencers} />
      <AllInflReq influencers={influencers} />
    </main>
  );
}

export default InfluencersComingSoonPage;
